// Main Menu
(function () {
  'use strict';

  function addAccessibleNavigationStyles() {
    if (document.getElementById('accessible-navigation-styles')) return;

    const style = document.createElement('style');

    style.id = 'accessible-navigation-styles';

    style.textContent = `
      .navigation__item--keyboard-open > .navigation__tier-2-container,
      .navigation__item--keyboard-open > .navigation__tier-3-container,
      .navigation__item--keyboard-open > .navigation__child-tier {
        visibility: visible !important;
        opacity: 1 !important;
        pointer-events: auto !important;
        z-index: 11 !important;
      }
    `;

    document.head.appendChild(style);
  }

  function getSubmenu(item) {
    return item.querySelector(
      ':scope > .navigation__tier-2-container, ' +
      ':scope > .navigation__tier-3-container'
    );
  }

  function closeSiblingMenus(currentItem) {
    const parent = currentItem.parentElement;

    if (!parent) return;

    parent
      .querySelectorAll(':scope > .navigation__item--with-children')
      .forEach(function (sibling) {
        if (sibling === currentItem) return;

        sibling.classList.remove(
          'navigation__item--keyboard-open',
          'navigation__item--show-children'
        );

        const trigger = sibling.querySelector(
          ':scope > .navigation__link, :scope > .navigation__column-title'
        );

        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }

        const submenu = getSubmenu(sibling);

        if (submenu) {
          submenu.setAttribute('aria-hidden', 'true');
        }
      });
  }

  function openMenu(trigger, item) {
    closeSiblingMenus(item);

    trigger.setAttribute('aria-expanded', 'true');

    item.classList.add('navigation__item--keyboard-open');
    item.classList.add('navigation__item--show-children');

    const submenu = getSubmenu(item);

    if (submenu) {
      submenu.setAttribute('aria-hidden', 'false');
    }
  }

  function closeMenu(trigger, item) {
    trigger.setAttribute('aria-expanded', 'false');

    item.classList.remove(
      'navigation__item--keyboard-open',
      'navigation__item--show-children'
    );

    const submenu = getSubmenu(item);

    if (submenu) {
      submenu.setAttribute('aria-hidden', 'true');
    }
  }

  function toggleMenu(trigger, item) {
    const expanded =
      trigger.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      closeMenu(trigger, item);
    } else {
      openMenu(trigger, item);
    }
  }

  function setupNavigation() {
    const items = document.querySelectorAll(
      '.navigation__item--with-children'
    );

    items.forEach(function (item) {
      if (item.closest('.mobile-navigation-drawer')) return;
      const trigger = item.querySelector(
        ':scope > .navigation__link, :scope > .navigation__column-title'
      );

      const submenu = getSubmenu(item);

      if (!trigger || !submenu) return;

      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-haspopup', 'true');

      let submenuId = submenu.getAttribute('id');

      if (!submenuId) {
        submenuId =
          'accessible-navigation-' +
          Math.random().toString(36).substring(2, 10);

        submenu.setAttribute('id', submenuId);
      }

      trigger.setAttribute('aria-controls', submenuId);

      if (!trigger.hasAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (trigger.dataset.accessibleNavigationReady === 'true') {
        return;
      }

      trigger.dataset.accessibleNavigationReady = 'true';

      submenu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          closeMenu(trigger, item);
          trigger.focus();
        }
      });

      new MutationObserver(function () {
        var open = item.classList.contains('navigation__item--show-children') || item.classList.contains('navigation__item--keyboard-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }).observe(item, { attributes: true, attributeFilter: ['class'] });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();

          toggleMenu(trigger, item);
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();

          closeMenu(trigger, item);
          trigger.focus();
        }
      });

      trigger.addEventListener('click', function (event) {
        if (trigger.dataset.keyboardClick === 'true') {
          event.preventDefault();
          event.stopPropagation();

          trigger.dataset.keyboardClick = 'false';
        }
      });
    });
  }

  function init() {
    addAccessibleNavigationStyles();
    setupNavigation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver(function () {
    setupNavigation();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Back to top
document.querySelector('#back-to-top').addEventListener('click', function () {
  const target = document.querySelector('#top-back');

  if (target) {
    target.setAttribute('tabindex', '-1');
    target.focus();
  }
});

// Accessible Filters
document.addEventListener('DOMContentLoaded', function () {
  const filterButton = document.querySelector('[data-toggle-filters]');

  if (!filterButton) return;

  // Make it an accessible button
  filterButton.setAttribute('role', 'button');
  filterButton.setAttribute('aria-expanded', 'false');

  filterButton.addEventListener('click', function () {
    // Wait for the theme's filter script to finish
    setTimeout(function () {
      const expanded = filterButton.getAttribute('aria-expanded') === 'true';

      filterButton.setAttribute(
        'aria-expanded',
        expanded ? 'false' : 'true'
      );
    }, 100);
  });

  // Keyboard support
  filterButton.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      filterButton.click();
    }
  });
});

// External links Warning 
document.addEventListener("DOMContentLoaded", function () {
  const excludedLinks = [
    'https://www.facebook.com/'
  ];

  const normalizeHost = (host) => host.replace(/^www\./, '');

  const isExternalLink = (url) => {
    try {
      const linkUrl = new URL(url, window.location.origin); // handles relative URLs
      const linkHost = normalizeHost(linkUrl.hostname);
      const currentHost = normalizeHost(window.location.hostname);

      return linkHost && linkHost !== currentHost;
    } catch {
      return false;
    }
  };

  const enhanceExternalLinks = () => {
    const links = document.querySelectorAll('a');

    links.forEach(link => {
      const href = link.getAttribute('href');

      if (
        !href ||
        excludedLinks.includes(href) ||
        link.matches('li[data-submenu-parent] > a') ||
        !isExternalLink(href)
      ) return;

      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      const linkText = link.textContent.trim();

      if (!link.hasAttribute('aria-label')) {
        link.setAttribute(
          'aria-label',
          `${linkText}, Redirecting to a third-party website (opens in a new tab).`
        );
      }

      const img = link.querySelector('img, svg');
      if (img) {
        const altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, Redirecting to a third-party website (opens in a new tab).`
          : 'Redirecting to a third-party website (opens in a new tab).';

        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  const enhanceContactLinks = () => {
    const contactLinks = document.querySelectorAll(
      'a[href^="mailto:"], a[href^="tel:"]'
    );

    contactLinks.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  enhanceExternalLinks();
  enhanceContactLinks();
});

// adding the label to empty heading
document.querySelectorAll('th').forEach(function (th) {
  if (!th.textContent.trim()) {
    const span = document.createElement('span');
    span.className = 'visually-hidden';
    span.style.fontSize = '0px';
    span.textContent = 'Size';
    th.appendChild(span);
  }
});

// Mobile menu: aria-expanded, focus in/out, Escape (RW audit Oct 2026)
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('button.mobile-nav-toggle');
  if (!toggle) return;
  function drawer() { var d = document.querySelector('.mobile-navigation-drawer'); if (d && !d.id) d.id = 'MobileNavDrawer'; return d; }
  function isOpen() { return document.body.classList.contains('reveal-mobile-nav'); }
  new MutationObserver(function () {
    var open = isOpen(), d = drawer();
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && d && !d.contains(document.activeElement)) { var x = d.querySelector('.mobile-nav-toggle'); setTimeout(function () { (x || d).focus(); }, 60); }
    if (!open && d && d.contains(document.activeElement)) { toggle.focus(); }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) { var d = drawer(), x = d && d.querySelector('.mobile-nav-toggle'); if (x) x.click(); }
  });
  document.querySelectorAll('a.filters__close').forEach(function (a) { a.setAttribute('role', 'button'); });
});
